import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Returning the component
class FormSelect extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedValue: this.props.selectedValue
		}
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ selectedValue: nextProps.selectedValue });
	}
	render() {
		return (
			<select value={this.state.selectedValue} className={`form__select ${this.props.classType}`} id={this.props.id} name={this.props.name} form={this.props.form} onClick={this.props.onClick} onChange={this.props.onChange}>
				{this.props.selectData ? this.props.selectData.map((item, i) => {	
					return <option value={item.value} key={i}>{item.name}</option>
				}): <option>Select a value</option>}
			</select>
		)
	}
}

//Default properties if they are not set
FormSelect.defaultProps = {
	classType: ""
};

//Making sure that it has a text property when it's declared
FormSelect.propTypes = {
	classType: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func
}

export default FormSelect;


// WEBPACK FOOTER //
// ./src/redux/components/atoms/FormSelect.jsx